<!-- 网站首页 -->
<template>
  <div class="page_content p_flex p_align_items p_space_between">
    <div class="login_bg hidden-xs hidden-sm hidden-md">
      <img class="login_logo" src="@/assets/images/login/login_logo.png" alt="" />
      <span class="footer_biao font_14 color_ffffff">© 2023 SNAIL SHELL</span>
    </div>
    <div class="login_right p_flex1 p_flex p_align_items p_justify_center">
      <!-- 登录 -->
      <signin v-if="$route.path==='/login'"></signin>
      <!-- 注册 -->
      <register v-if="$route.path==='/signUp'"></register>
      <!-- 修改密码 -->
      <editpassword v-if="$route.path==='/reset'"></editpassword>
    </div>
  </div>
</template>
<script>
import signin from './children/signin.vue';
import register from './children/register.vue';
import editpassword from './children/editpassword.vue';
export default {
  data() {
    return {
    };
  },
  components: { signin, register,editpassword},
  created() {
  },
  mounted() {},
  computed: {},
  methods: {}
};
</script>

<style scoped="scoped">
.page_content {
  font-size: 12px;
  height: 100vh;
}
.footer_biao {
  position: absolute;
  left: 60px;
  bottom: 60px;
}
.login_logo {
  position: absolute;
  top: 60px;
  left: 60px;
  width: 60px;
  height: 103px;
}
.login_bg {
  position: relative;
  width: 38.888vh;
  height: 100vh;
  background-image: url('https://wozhike-1306886396.cos.ap-nanjing.myqcloud.com/cimg/0253565109.png');
  background-size: 100%;
  background-position: top center;
  background-repeat: no-repeat;
}
.login_right {
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue